import React from "react";

// |-- External Dependencies --|
import DispositionLevelOneListingWrapper from "./DispositionLevelOne/List/DispositionLevelOneListingWrapper";
import DispositionLevelTwoListingWrapper from "./DispositionLevelTwo/List/DispositionLevelTwoListingWrapper";

const Dispositions = () => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4 p-3 overflow-auto">
        {/* Disposition Level One */}
        <div className="h-full">
          <DispositionLevelOneListingWrapper />
        </div>

        {/* Disposition Level Two */}
        <div className="h-full ">
          <DispositionLevelTwoListingWrapper />
        </div>
      </div>
    </>
  );
};

export default Dispositions;
